import { IApplicationState } from "app/store";
import React from "react";
import { Provider } from "react-redux";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import { Store } from "redux";
import {
  AnalyticsProvider,
  Authenticator,
  AuthProvider,
  BrowserPatcher,
  ErrorTrackingProvider,
} from "component-library";

import { BASE_PATH } from "config/common";
import config from "config/global";

import ErrorBoundary from "app-shell/ErrorBoundary/ErrorBoundary";
import { GoogleTagManager } from "app-shell/GoogleTagManager/GoogleTagManager";

import App from "../../App";
import { QueryClient, QueryClientProvider } from "react-query";

interface IRootProps {
  store: Store<IApplicationState>;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export class Root extends React.Component<IRootProps> {
  public render() {
    return (
      <AuthProvider>
        <Authenticator>
          <AnalyticsProvider>
            <ErrorTrackingProvider appName="nujobs-app">
              <Provider store={this.props.store}>
                <ErrorBoundary>
                  <BrowserPatcher />
                  <GoogleTagManager {...config.gtm} />
                  <QueryClientProvider client={queryClient}>
                    <Router>
                      <Switch>
                        <Route path={BASE_PATH}>
                          <App />
                        </Route>
                        <Route>
                          <Redirect to={BASE_PATH} />
                        </Route>
                      </Switch>
                    </Router>
                  </QueryClientProvider>
                </ErrorBoundary>
              </Provider>
            </ErrorTrackingProvider>
          </AnalyticsProvider>
        </Authenticator>
      </AuthProvider>
    );
  }
}
